/* eslint-disable no-unused-vars */
import React from 'react';
import {
  Button,
  Typography,
  Grid,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Divider,
  CardContent,
  CardActions
} from '@mui/material';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SubscriptionPlansCarousel from './SubscriptionPlansCarousel';
import { useGetSubcriptionForMachineList } from 'hooks/useMachineHooks';
import ContactUsDialog from './ContactUsDialog';
import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

const PricingTableDialog = ({ open, onClose }) => {
  const { data: subcriptionList, isLoading: isLoadingSubcriptionList } = useGetSubcriptionForMachineList({
    filters: { machineSubs: true }
  });
  const [openContactUs, setOpenContactUs] = useState(false);
  // console.log('Employee ~ PricingTableDialog ~ openDialog ~ ', open);
  const callInvoiceScreen = (id = '') => {
    // console.log('callInvoiceScreen | id', id);
    /*navigate('/dashboard/machines/create-invoice', {
      state: {
        machineObj: value,
        subId: id,
        subObj: subcriptionList && subcriptionList.length > 0 ? subcriptionList.filter((sub) => sub.id === id) : null
      }
    });*/
  };
  const onHandleClose = (event, reason) => {
    // Prevent closing if the reason is 'backdropClick' or 'escapeKeyDown'
    if (reason && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
      return;
    }
    onClose(); // Close the dialog only when explicitly triggered (e.g., button click)
  };

  return (
    <>
      <Dialog open={open.show} onClose={onHandleClose} maxWidth="xl" fullWidth>
        <DialogTitle sx={{ paddingBottom: 0 }}>
          <Typography className="skip-heading" component="h4" variant="h2" sx={{ mb: 2 }}>
            {open.status === 402 ? 'Upgrade Subscription' : null}
            {open.status === 403 ? 'Choose Subscription' : null}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500]
            })}
          >
            <CloseIcon color="error" />
          </IconButton>
        </DialogTitle>
        {/* <Divider /> */}
        <DialogContent dividers>
          {/* <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12}>
            <Box
              className="skip-btn"
              sx={{
                position: 'absolute', // Position the button absolutely
                right: 20, // Space from the right edge of the page
                top: '5%', // Vertically center the button
                zIndex: 1000 // Ensure it is on top of other elements
              }}
            >
              <Button
                onClick={() => callInvoiceScreen('')}
                variant="contained"
                color="primary"
                endIcon={<SkipNextIcon />}
                sx={{ color: '#fff', fontWeight: 'unset', marginBottom: '20px' }}
              >
                Skip Subscription
              </Button>
            </Box>
          </Grid>
        </Grid> */}
          <Typography variant="h3" color="primary1">
            Previous Subcription Details
          </Typography>
          <CardContent>
            <Typography variant="h3" sx={{ color: 'text.secondary', fontSize: 14 }}>
              Previous Subcription Details
            </Typography>
            <Typography variant="h5" component="div">
              benev
            </Typography>
            <Typography sx={{ color: 'text.secondary', mb: 1.5 }}>adjective</Typography>
            <Typography variant="body2">
              well meaning and kindly.
              <br />
              {'"a benevolent smile"'}
            </Typography>
          </CardContent>
          <SubscriptionPlansCarousel
            subcriptionList={subcriptionList}
            isLoadingSubcriptionList={isLoadingSubcriptionList}
            callInvoiceScreen={callInvoiceScreen}
            openContactUs={openContactUs}
            setOpenContactUs={setOpenContactUs}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {openContactUs && <ContactUsDialog open={openContactUs} setOpen={setOpenContactUs} />}
    </>
  );
};

export default PricingTableDialog;
